/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 12/23/2019
 *
 */

import React from 'react';
import {Route, Redirect} from "react-router-dom";

const ProtectedRoute = ({ component: Comp, path, roles, ...rest }) => {
    let user = JSON.parse(localStorage.getItem('tmcUser'));

    return (
        <Route
            path={path}
            {...rest}
            render={props => {
                if (user === null || user.isAuthenticated === false)
                    return <Redirect to="/login" />;

                if (roles.indexOf(user.role) > -1)
                    return user.isAuthenticated
                        ? <Comp {...props} />
                        : <Redirect to="/login" />;
                else
                    return <Redirect to={{
                        pathname: "/error",
                        state: {errorCode: '401'}
                    }} />;
            }}
        />
    );
};

export default ProtectedRoute;
